import { CONNECTS_API_V2_SLUG, NEXUS_API_V2_SLUG, PAYMENTS_API_V2_SLUG } from 'src/constants'

import { FunctionComponent } from 'react'
import { NavLink } from 'react-router-dom'

const APiDocLinksV2: FunctionComponent = () => {
  return (
    <>
      <NavLink to={`/${CONNECTS_API_V2_SLUG}`} data-testid="connects-docs-v2-link">
        Connects API
      </NavLink>

      <NavLink to={`/${NEXUS_API_V2_SLUG}`} data-testid="nexus-docs-v2-link">
        Nexus API
      </NavLink>

      <NavLink to={`/${PAYMENTS_API_V2_SLUG}`} data-testid="payments-docs-v2-link">
        Payments API
      </NavLink>
    </>
  )
}

export default APiDocLinksV2
